export enum CustomerFlow {
  Order,
  Pay
}
